import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export type CredentialType = {
  id: number;
  website: string;
  username: string;
  password: string;
  comment: string;
  level: number;
  users: number[];
  createdAt: string;
  updatedAt: string;
  userId: number;
};

export const useMyPasswords = () => {
  return useQuery({
    queryKey: ['useMyPasswords'],
    queryFn: () =>
      axios
        .get(`${envApiUrl}/credentials/`, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          return response.data as CredentialType[];
        })
        .catch((error) => {
          if (error.response) {
            console.log('AAA: ', error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
          if (error.response?.status === 403) {
            window.location.href = '/';
          }
        }),
  });
};
